            
<template>  
  <div v-if="createdCycle">
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">       
                <b-form  inline style="margin-bottom:15px" novalidate> 
                  <b-row style="width:100%;margin-bottom:20px"  v-if="dataForm[namePath].info_aportes.id_list_forma!==1">                      
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_datos_razon"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline                          
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="5" :lg="5">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                          
                        <sw-inputs
                          class="col-lg-3 col-md-3 col-sm-12"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline>
                        </sw-inputs> 
                  </b-row>  
                  <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_aportes.id_list_forma===1">                      
                    <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_datos_razon"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="5" :lg="5">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                           
                        <sw-inputs
                          class="col-lg-3 col-md-3 col-sm-12"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline>
                        </sw-inputs>  
                        <b-col :md="4" :lg="4">
                        </b-col>                                          
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_cuentas"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar cuenta"
                          modalSize="sm"
                          :md="5" :lg="5">
                          <template v-slot:modal="modalInput">
                            <sw-modallistcuentas
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistcuentas>
                          </template>
                        </sw-inputs>  
                        <b-col :md="3" :lg="3">
                        </b-col>     
                        <b-col :md="4" :lg="4">
                        </b-col>    
                        <sw-inputs
                          style="margin-bottom:10px"
                          inputTabla="info_aportes"
                          inputCampo="consignacion"
                          inline
                          :md="5" :lg="5">
                        </sw-inputs>    
                  </b-row>
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="name" 
                      :searchs="['id_list_documento','documento','name']"
                      list="datos_aportes" 
                      inline
                      @buscar="buscarFtn"
                      :md="6" :lg="6">
                    </sw-inputs>  
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="documento"  
                      inline                   
                      :md="6" :lg="6">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="direccion"
                      inline
                      :md="6" :lg="6">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="email"
                      inline
                      :md="6" :lg="6">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="telefonos"
                      inline
                      :md="6" :lg="6">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="id_datos_asesor"
                      inline
                      :md="6" :lg="6">
                    </sw-inputs>                    
                  </b-row>  
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">                   
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="descripcion"
                      inline
                      :md="9" :lg="9">
                    </sw-inputs>                     
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="valor"
                      @input="dataForm[namePath].info_aportes.reporte=dataForm[namePath].info_aportes.valor"
                      inline
                      :md="3" :lg="3">
                    </sw-inputs>  
                    <b-col :md="9" :lg="9"></b-col>                   
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="reporte"
                      inline
                      :md="3" :lg="3">
                    </sw-inputs>              
                  </b-row>  
                  <b-row style="width:100%">                                
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="observacion"
                      :md="12" :lg="12">
                    </sw-inputs>
                  </b-row>    
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px -15px; padding: 0 0 15px">
         <b-row align-v="center" style="width:100%">
           <b-col :md="6" :lg="6"></b-col>
            <sw-inputs
              inputTabla="info_aportes"
              inputCampo="id_list_mes"
              :md="2" :lg="2">
            </sw-inputs>   
            <sw-inputs
              inputTabla="info_aportes"
              inputCampo="id_list_ano"
              :md="2" :lg="2">
            </sw-inputs>        
           <b-col>  
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn=""
              :invalid="dataForm[namePath].info_aportes.name===null || dataForm[namePath].info_aportes.name===''"
              @save="save"
              >
            </sw-saveform>
           </b-col>
         </b-row>
      </footer>
    </validation-observer>
  </div> 
  <div v-else>
    <sw-loading></sw-loading> 
  </div>
  
</template>
<script>
import { mapState, mapActions } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwLoading from '@/components/notification/loading.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas,
    SwLoading  
  },
  props: {
  },
  data()
  {
    return {     
      createdCycle: false,     
      saveEvent:false,      
    }
  },
  async updated()
  {    
  },
  async created(){  
    
    let getBackend = await this.getData({route: 'datos_aportes', data: 1})

    const await6 = this.updateDataForm({state: 'info_aportes/fecha', data: this.fecha().fecha.minHoy})
    const await0 = this.updateDataForm({state: 'info_aportes/id_datos_asesor', data: 1})
    const await1 = this.updateDataForm({state: 'info_aportes/descripcion', data: null})
    const await2 = this.updateGlobal({state:'openModal/modal/loaded',data:true})
    const await3 = this.updateCrud({state: 'lists/datos_aportes', data: getBackend })
    const await4 = this.updateDataForm({state: 'info_aportes/id_list_mes', data: this.fecha().fecha.mesHoy})
    const await5 = this.updateDataForm({state: 'info_aportes/id_list_ano', data:  this.fecha().fecha.anoHoy})
    
    await Promise.all([await0,await1,await2,await3,await4,await5,await6])
    this.createdCycle=true
  },
  destroyed()
  {
      this.resetDataIndex()
      this.resetDataPost()
  },
  computed: { 
  },
  methods: {
		...mapActions({			
			assignDataForm: 'crudStore/assignDataForm',
		}),
    async save(event)
    {      
      
        if(this.dataForm[this.namePath].info_aportes.id_list_forma==2 || this.dataForm[this.namePath].info_aportes.id_list_forma==5)
        {
          await this.updateDataForm({state: 'info_aportes/fecha', data: null})
        }
        await this.updateDataForm({state: 'info_aportes/servicios', data: 2})
        this.$emit('save',{save:event.save, ftn: 'registroFtn'})  
        return true 
    },
    async buscarFtn(event)
    {
      
      let datos_aportes= this.gettersDatalist('datos_aportes',event)[0]

      let info_aportes= { name: datos_aportes.name, direccion: datos_aportes.direccion, documento: datos_aportes.documento, telefonos: datos_aportes.telefonos, email: datos_aportes.email, id_list_documento: datos_aportes.id_list_documento}

      await this.assignDataForm({state: 'info_aportes', data: info_aportes})
    }
  }  
}
</script>
<style>
</style>